module.exports = "<svg id=\"7ac7db3b-bcfc-4078-bc3b-1e37ff1cfc38\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>home-star</title><polygon points=\"25 40.33 9.84 48.29 12.78 31.46 0.5 19.52 17.45 17.05 25 1.71 32.55 17.05 49.5 19.52 37.22 31.46 40.16 48.29 25 40.33\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home-star.svg
// module id = aoje
// module chunks = 1